/**
 * MidLogo, Logótipo oficial miD (Mediador Imobiliário Digital).
 *
 * Usa o PNG real da marca (versão light-bg por omissão, dark-bg disponível).
 * Substitui o antigo pattern "Briefcase + texto miD".
 *
 * Props:
 *  - variant: "light" (para fundo claro/branco) | "dark" (para fundo escuro)
 *  - size:    "sm" (24px) | "md" (32px) | "lg" (44px) | "xl" (64px), altura do ícone
 *  - showBadge: texto opcional a aparecer ao lado (ex: "Agente", "Admin")
 *  - className: classes Tailwind extra para o wrapper
 */
import { cn } from '../lib/utils';
import { NEW_BRAND } from '../lib/brand';
import { BrandLogo } from './brand/BrandLogo';

const LIGHT_SRC = '/brand/mid-logo-light.png';
const DARK_SRC = '/brand/mid-logo-dark.png';

// Zonamento lockup height per size, matching the old icon heights (mid-v6k8.8).
const BRAND_HEIGHT = { sm: 28, md: 40, lg: 56, xl: 80 };

const SIZE_CLASSES = {
  sm: 'h-7',
  md: 'h-10',
  lg: 'h-14',
  xl: 'h-20',
};

export function MidLogo({
  variant = 'light',
  size = 'md',
  showBadge,
  badgeTone = 'teal',
  className,
  onClick,
  'data-testid': dataTestId = 'mid-logo',
}) {
  const src = variant === 'dark' ? DARK_SRC : LIGHT_SRC;
  const isClickable = typeof onClick === 'function';

  const badgeStyles = {
    teal: { background: 'var(--mid-teal-muted)', color: 'var(--mid-teal-dark)' },
    purple: { background: 'var(--mid-lilac-muted)', color: 'var(--mid-purple)' },
    light: { background: 'color-mix(in srgb, var(--brand-on-primary, #fff) 14%, transparent)', color: 'var(--brand-on-primary, #fff)' },
  };

  return (
    <div
      className={cn('flex items-center gap-2', isClickable && 'cursor-pointer', className)}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {NEW_BRAND ? (
        <BrandLogo
          height={BRAND_HEIGHT[size] || BRAND_HEIGHT.md}
          tone={variant === 'dark' ? 'night' : 'auto'}
          label="miD, Mediador Imobiliário Digital"
          className="select-none"
        />
      ) : (
        <img
          src={src}
          alt="miD, Mediador Imobiliário Digital"
          className={cn('w-auto select-none', SIZE_CLASSES[size] || SIZE_CLASSES.md)}
          draggable={false}
        />
      )}
      {showBadge && (
        <span
          className="text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap"
          style={badgeStyles[badgeTone] || badgeStyles.teal}
        >
          {showBadge}
        </span>
      )}
    </div>
  );
}

export default MidLogo;
